module.exports = __webpack_public_path__ + "img/446-43b8c0.png";